import React from 'react';
import {ProtectedRoute} from '../../_common/components/Permissions';
import PriceCatalogPage from '../pages';
import {pathnames as P} from '../../_common/constants/pathnames';
import {subjects as S} from '../../_common/constants/permissionSubjects';

export const priceCatalogRoute = (
  <ProtectedRoute
    subject={S.PRICE_CATALOG_PAGE}
    path={P.PRICE_CATALOG_PAGE}
    component={PriceCatalogPage}
  />
);
